var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsumption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.759,
    height: 31.417,
    viewBox: "0 0 31.759 31.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784",
    transform: "translate(6858.109 5393.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773",
    transform: "translate(115.658 13.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M-6047.212-4584.074h4.766l-2.4,5.084h4.606l-6.969,8.25,1.421-4.967h-3.785Z",
    transform: "translate(-902.139 -807.232)",
    fill: "none",
    stroke: "#084688",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M-6215.959-4779.632V-4791.7a4.23,4.23,0,0,0-4.215-3.378,4.085,4.085,0,0,0-4.056,3.378v23.275a4.65,4.65,0,0,1-4.576,4.007c-4.125.16-4.884-4.007-4.884-4.007v-2.464",
    transform: "translate(-731.501 -611.674)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M-6265.187-4488.072a2.369,2.369,0,0,0,2.224,1.842,2.062,2.062,0,0,0,2.042-1.842",
    transform: "translate(-702.308 -896.355)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    transform: "translate(-6968.799 -5388.007)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.1,
    height: 1.903,
    rx: 0.951,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 6.35,
    height: 1.153,
    rx: 0.576,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    transform: "translate(-6968.799 -5386.251)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.1,
    height: 1.903,
    rx: 0.951,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 6.35,
    height: 1.153,
    rx: 0.576,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1053",
    "data-name": "Path 1053",
    transform: "translate(-6971.8 -5400.011)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.441,0A6.435,6.435,0,0,1,9.529,12.084L6.518,12.1l-3.074.047A6.442,6.442,0,0,1,6.441,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.440818309783936 0.7499980926513672 C 3.302887916564941 0.7499980926513672 0.7499980926513672 3.302898406982422 0.7499980926513672 6.440828323364258 C 0.7499980926513672 8.506472587585449 1.848464965820312 10.38621520996094 3.629055976867676 11.39062881469727 L 6.515018463134766 11.34687805175781 L 9.328554153442383 11.33457088470459 C 11.0622501373291 10.30685234069824 12.1316385269165 8.448561668395996 12.1316385269165 6.440828323364258 C 12.1316385269165 3.302898406982422 9.57874870300293 0.7499980926513672 6.440818309783936 0.7499980926513672 M 6.440818309783936 -1.9073486328125e-06 C 9.997987747192383 -1.9073486328125e-06 12.8816385269165 2.883658409118652 12.8816385269165 6.440828323364258 C 12.8816385269165 8.873928070068359 11.53704833984375 10.9787483215332 9.529038429260254 12.08369827270508 L 6.518298149108887 12.09686851501465 L 3.444098472595215 12.14351844787598 C 1.404928207397461 11.07849788665771 -1.9073486328125e-06 8.923727989196777 -1.9073486328125e-06 6.440828323364258 C -1.9073486328125e-06 2.883658409118652 2.883647918701172 -1.9073486328125e-06 6.440818309783936 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#084688"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M-6343.628-4734.969l2.478,2.5",
    transform: "translate(-629.609 -666.43)",
    fill: "none",
    stroke: "#084688",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M-6238.059-4773.192v3.117",
    transform: "translate(-727.451 -631.004)",
    fill: "none",
    stroke: "#084688",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M-6162.651-4732.785l-2.238,2.318",
    transform: "translate(-795.266 -668.455)",
    fill: "none",
    stroke: "#084688",
    strokeLinecap: "round",
    strokeWidth: 0.75
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumption);
export default __webpack_public_path__ + "static/media/consumption.1401fe2c.svg";
export { ForwardRef as ReactComponent };